import { Signal, computed } from '@angular/core';
import { applyWhenValue, pattern, required, schema } from '@angular/forms/signals';
import { patterns } from '@mapa/esm';
import Fuse from 'fuse.js';
import { Country } from '../api/csc.api';

export interface PhoneNumberWithCode {
  code: string;
  number: string;
}

export type PhoneCodeOption = {
  id: string;
  flag: string;
  code: string;
  name: string;
  countryId: number;
};

export function getPhoneCodeOptions(countries: Country[]) {
  const mapped = [] as PhoneCodeOption[];

  countries.forEach(country => {
    if (country.phonecode.includes('and')) {
      const codes = country.phonecode.split(' and ');
      codes.forEach(code => mapped.push({
        id: `${code}/${country.name}`,
        countryId: country.id,
        flag: country.emoji,
        name: country.name,
        code
      }));
    }
    else {
      mapped.push({
        id: `${country.phonecode}/${country.name}`,
        countryId: country.id,
        flag: country.emoji,
        name: country.name,
        code: country.phonecode
      });
    }
  });

  return mapped;
}

export function filterCountryCode(all$: Signal<PhoneCodeOption[]>, query$: Signal<string>) {
  const index$ = computed(() => new Fuse(all$(), {
    keys: ['code']
  }));

  return computed(() => {
    const q = query$().trim();
    if (q)
      return index$().search(q).map(r => r.item);

    return all$();

  });
}

const requireBothValues = schema<PhoneNumberWithCode>(p => {
  required(p.code, { message: 'Needs both code and number' });
  required(p.number, { message: 'Needs both code and number' });
});

export const phoneNumberWithCodeSchema = schema<PhoneNumberWithCode>(p => {
  pattern(p.code, patterns.telephone);
  pattern(p.number, patterns.telephone);

  applyWhenValue(p,
    value => value.code.length > 0 || value.number.length > 0,
    requireBothValues
  );
});

export function getCombinedNumber(value: PhoneNumberWithCode) {
  const code = value.code.replaceAll(' ', '');
  return value.code ? `+${code} ${value.number}` : null;
}
